import { useEffect, useState, useRef } from "react";
import fetch from "node-fetch";
import { useJSONFetcher } from "@outplayed/json-fetcher";

const acceptedTypes = ["item", "spell", "talent"];

/**
 * Gets WoW static data for an item, spell, or talent. When using this function check if the data is undefined.
 * @param {*} type Either "item" or "spell" or "talent"
 * @param {*} id Id of the object to get
 * @returns
 */
export function getWowStatic(type, id) {
  const { data: staticData } = useJSONFetcher(`https://static.bigbrain.gg/wow/${type}/${id}.json`, {
    ssr: true,
    skip: !id || !type,
  });
  return staticData;
}
